import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { QuestionnaireCategoryCountDto } from "src/app/models/questionnaireCategory.model";
import { PageResult } from "src/app/shared/models/pageResult";
import { QuestionnaireDatails } from "../../display-questionnaires/models/questionnarieDeatails";
import { FilterQuestionnaires } from "../../display-questionnaires/models/filterQuestionnaires.model";
import { QuestionnaireRow } from "src/app/models/questionnaireGrid.model";
import { Observable, of } from "rxjs";
import { DateRangeFilter, DateRangeTypeEnum, FilterItemList, SelectedFilter } from "src/app/shared/models/filter.model";
import { environment } from 'src/environment';
import { StatusFlowDto } from "src/app/models/approval.model";


@Injectable({ providedIn: 'root' })
export class QuestionnairesGridApiService {
    #httpservice = inject(HttpClient);
    #gridUrl = `${environment.apiUrl}/questionnairesGrid`;
    #QuestionnaireUrl = `${environment.apiUrl}/questionnaires`;


    getQuestionnaries = (page: number, selectedFilter: SelectedFilter) => this.#httpservice.post<PageResult<QuestionnaireRow>>(`${this.#gridUrl}/getQuestionnaires`, { paging: page, selectedFilter });

    getQuestionnariesExtra = (page: number, selectedFilter: SelectedFilter) => this.#httpservice.post<PageResult<QuestionnaireRow>>(`${this.#gridUrl}/getQuestionnairesExtra`, { paging: page, selectedFilter });

    getQustionnariesDetails = (filter: FilterQuestionnaires) => { return this.#httpservice.get<QuestionnaireDatails[]>(`${this.#gridUrl}/getQuestionnairesDetails`) }

    deleteQuestionnairesById = (id: number) => {
        return this.#httpservice.delete(`${this.#QuestionnaireUrl}/deleteQuestionnaireById/${id}`);
    }

    duplicateQuestionnairesById = (id: number, name?: string) => {
        return this.#httpservice.post<number>(`${this.#QuestionnaireUrl}/duplicateQuestionnaireById`, { id, name });
    }

    cancelRequest(guid?: string) {
        return this.#httpservice.post<void>(`${this.#gridUrl}/cancelRequest/${guid}`, {});
    }

    duplicateRequest(guid?: string) {
        return this.#httpservice.post<string>(`${this.#gridUrl}/duplicateRequest/${guid}`, {});
    }

    getStatusFlow(guid?: string){
        return this.#httpservice.post<StatusFlowDto[]>(`${this.#gridUrl}/getStatusFlow/${guid}`, {});
    }
}